import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";

export default function AuthLayout({ children }: React.PropsWithChildren<{}>) {
  return (
    <>
      <Header />
      <main className="min-h-screen w-full flex flex-col items-center gap-6 py-6">
        {children}
        <Outlet />
      </main>
    </>
  );
}
